// src/components/themes/index.ts
import DefaultBranchLogin from "./default/admin/BranchLogin";
import NeonStudioBranchLogin from "./neon_studio/admin/BranchLogin";
import ClassifiedSoftBranchLogin from "./classified_soft/admin/BranchLogin";

export const getThemeBranchLogin = (themeKey: string) => {
  switch (themeKey) {
    case "neon_studio":
      return NeonStudioBranchLogin;
    case "classified_soft":
      return ClassifiedSoftBranchLogin;
    case "default":
    default:
      return DefaultBranchLogin;
  }
};